//在这个文件中根路由 / 必须定义，children可自定义
const _import = require("../_import_" + process.env.NODE_ENV);

const routes = [
  {
    path: "/",
    name: "Login",
    component: _import("Login"),
    meta: {
      parent: 0,
    },
    children: [
      {
        path: "/serverDetail",
        name: "serverDetail",
        component: _import("volunteer/serverDetail"),
        meta: {
          menuName: "服务工作详情",
          index: 1, //面包屑顺序
        },
      },
      {
        path: "/videoPlay",
        name: "videoPlay",
        component: _import("volunteer/videoPlay"),
        meta: {
          menuName: "活动视频",
          index: 1, //面包屑顺序
        },
      },
    ],
  },
];
export default routes;
